export var HdsIconlibraryFile_24px;
(function (HdsIconlibraryFile_24px) {
    HdsIconlibraryFile_24px["ArchiveOutline_24px"] = "archive_outline_24px";
    HdsIconlibraryFile_24px["ArchiveSolid_24px"] = "archive_solid_24px";
    HdsIconlibraryFile_24px["CopyOutline_24px"] = "copy_outline_24px";
    HdsIconlibraryFile_24px["CopySolid_24px"] = "copy_solid_24px";
    HdsIconlibraryFile_24px["DocFileOutline_24px"] = "DOC-File_outline_24px";
    HdsIconlibraryFile_24px["DocFileSolid_24px"] = "DOC-File_solid_24px";
    HdsIconlibraryFile_24px["EpsFileOutline_24px"] = "EPS-File_outline_24px";
    HdsIconlibraryFile_24px["EpsFileSolid_24px"] = "EPS-File_solid_24px";
    HdsIconlibraryFile_24px["FileOutline_24px"] = "file_outline_24px";
    HdsIconlibraryFile_24px["FileSolid_24px"] = "file_solid_24px";
    HdsIconlibraryFile_24px["GifFileOutline_24px"] = "GIF-File_outline_24px";
    HdsIconlibraryFile_24px["GifFileSolid_24px"] = "GIF-File_solid_24px";
    HdsIconlibraryFile_24px["HtmlFileOutline_24px"] = "HTML-File_outline_24px";
    HdsIconlibraryFile_24px["HtmlFileSolid_24px"] = "HTML-File_solid_24px";
    HdsIconlibraryFile_24px["ImageOutline_24px"] = "image_outline_24px";
    HdsIconlibraryFile_24px["ImageSolid_24px"] = "image_solid_24px";
    HdsIconlibraryFile_24px["JpgFileOutline_24px"] = "JPG-File_outline_24px";
    HdsIconlibraryFile_24px["JpgFileSolid_24px"] = "JPG-File_solid_24px";
    HdsIconlibraryFile_24px["JsonFileOutline_24px"] = "JSON-File_outline_24px";
    HdsIconlibraryFile_24px["JsonFileSolid_24px"] = "JSON-File_solid_24px";
    HdsIconlibraryFile_24px["Mp3FileOutline_24px"] = "MP3-File_outline_24px";
    HdsIconlibraryFile_24px["Mp3FileSolid_24px"] = "MP3-File_solid_24px";
    HdsIconlibraryFile_24px["PdfFileOutline_24px"] = "PDF-File_outline_24px";
    HdsIconlibraryFile_24px["PdfFileSolid_24px"] = "PDF-File_solid_24px";
    HdsIconlibraryFile_24px["PngFileOutline_24px"] = "PNG-File_outline_24px";
    HdsIconlibraryFile_24px["PngFileSolid_24px"] = "PNG-File_solid_24px";
    HdsIconlibraryFile_24px["SvgFileOutline_24px"] = "SVG-File_outline_24px";
    HdsIconlibraryFile_24px["SvgFileSolid_24px"] = "SVG-File_solid_24px";
    HdsIconlibraryFile_24px["TiffFileOutline_24px"] = "TIFF-File_outline_24px";
    HdsIconlibraryFile_24px["TiffFileSolid_24px"] = "TIFF-File_solid_24px";
    HdsIconlibraryFile_24px["TxtFileOutline_24px"] = "TXT-File_outline_24px";
    HdsIconlibraryFile_24px["TxtFileSolid_24px"] = "TXT-File_solid_24px";
    HdsIconlibraryFile_24px["WavFileOutline_24px"] = "WAV-File_outline_24px";
    HdsIconlibraryFile_24px["WavFileSolid_24px"] = "WAV-File_solid_24px";
    HdsIconlibraryFile_24px["ZipOutline_24px"] = "ZIP_outline_24px";
    HdsIconlibraryFile_24px["ZipSolid_24px"] = "ZIP_solid_24px";
})(HdsIconlibraryFile_24px = HdsIconlibraryFile_24px || (HdsIconlibraryFile_24px = {}));
export const HDS_ICONLIBRARY_FILE_24PX_CODEPOINTS = {
    [HdsIconlibraryFile_24px.ArchiveOutline_24px]: '61697',
    [HdsIconlibraryFile_24px.ArchiveSolid_24px]: '61698',
    [HdsIconlibraryFile_24px.CopyOutline_24px]: '61699',
    [HdsIconlibraryFile_24px.CopySolid_24px]: '61700',
    [HdsIconlibraryFile_24px.DocFileOutline_24px]: '61701',
    [HdsIconlibraryFile_24px.DocFileSolid_24px]: '61702',
    [HdsIconlibraryFile_24px.EpsFileOutline_24px]: '61703',
    [HdsIconlibraryFile_24px.EpsFileSolid_24px]: '61704',
    [HdsIconlibraryFile_24px.FileOutline_24px]: '61705',
    [HdsIconlibraryFile_24px.FileSolid_24px]: '61706',
    [HdsIconlibraryFile_24px.GifFileOutline_24px]: '61707',
    [HdsIconlibraryFile_24px.GifFileSolid_24px]: '61708',
    [HdsIconlibraryFile_24px.HtmlFileOutline_24px]: '61709',
    [HdsIconlibraryFile_24px.HtmlFileSolid_24px]: '61710',
    [HdsIconlibraryFile_24px.ImageOutline_24px]: '61711',
    [HdsIconlibraryFile_24px.ImageSolid_24px]: '61712',
    [HdsIconlibraryFile_24px.JpgFileOutline_24px]: '61713',
    [HdsIconlibraryFile_24px.JpgFileSolid_24px]: '61714',
    [HdsIconlibraryFile_24px.JsonFileOutline_24px]: '61715',
    [HdsIconlibraryFile_24px.JsonFileSolid_24px]: '61716',
    [HdsIconlibraryFile_24px.Mp3FileOutline_24px]: '61717',
    [HdsIconlibraryFile_24px.Mp3FileSolid_24px]: '61718',
    [HdsIconlibraryFile_24px.PdfFileOutline_24px]: '61719',
    [HdsIconlibraryFile_24px.PdfFileSolid_24px]: '61720',
    [HdsIconlibraryFile_24px.PngFileOutline_24px]: '61721',
    [HdsIconlibraryFile_24px.PngFileSolid_24px]: '61722',
    [HdsIconlibraryFile_24px.SvgFileOutline_24px]: '61723',
    [HdsIconlibraryFile_24px.SvgFileSolid_24px]: '61724',
    [HdsIconlibraryFile_24px.TiffFileOutline_24px]: '61725',
    [HdsIconlibraryFile_24px.TiffFileSolid_24px]: '61726',
    [HdsIconlibraryFile_24px.TxtFileOutline_24px]: '61727',
    [HdsIconlibraryFile_24px.TxtFileSolid_24px]: '61728',
    [HdsIconlibraryFile_24px.WavFileOutline_24px]: '61729',
    [HdsIconlibraryFile_24px.WavFileSolid_24px]: '61730',
    [HdsIconlibraryFile_24px.ZipOutline_24px]: '61731',
    [HdsIconlibraryFile_24px.ZipSolid_24px]: '61732',
};
//# sourceMappingURL=hds-iconlibrary-file-24px.js.map